import { BOOLEAN_SELECT_LIST_ITEMS, Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
    ClassFilter as ClassFilterModel,
    ClassFilterResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ClassFilter = (props: {
    filter: ClassFilterModel;
    setFilter: (value: ClassFilterModel) => void;
}) => {
    const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
    const [resource, setResource] = useState<ClassFilterResource>({});
    const properties = resource.properties || [];

    useEffect(() => {
        ApiService.classes.getFilterResource().then((response) => {
            setResource(response);
        });
    }, []);

    const schoolField = () => {
        const propertyName = pn<ClassFilterModel>("schoolId");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                label="School"  
                value={resource.schools?.find((x) => x.id === props.filter.schoolId)}
                options={resource.schools}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) =>
                    props.setFilter(
                        produce(props.filter, (draft) => {
                            draft.schoolId = value?.id;
                        })
                    )
                }
            />
        );
    };

    const lockedField = () => {
        const propertyName = pn<ClassFilterModel>("locked");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.filter.locked)}
                options={BOOLEAN_SELECT_LIST_ITEMS}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) =>
                    props.setFilter(
                        produce(props.filter, (draft) => {
                            draft.locked = value?.id;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
                {schoolField()}
            </Grid>
            <Grid item xs={smallFieldBreakpoints}>
                {lockedField()}
            </Grid>
        </Grid>
    );
};
